import script from "./OrderItemTile.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderItemTile.vue?vue&type=script&setup=true&lang=js"

import "./OrderItemTile.vue?vue&type=style&index=0&id=26daa7a0&lang=scss"

const __exports__ = script;

export default __exports__